// Espejo del canónico aws_lambdas/_shared_autoescuela/permisosUsuario.js (permisos por usuario, 8/10/2026).
// NO editar el cuerpo aquí: se edita el canónico y se copia con
// `node aws_lambdas/_shared_autoescuela/permisosUsuarioCopias.js` (permisosUsuarioCopias.test.js lo fija).
// Ficha: docs/features/autoescuela-permisos-usuario.md
/* eslint-disable */
import { profesoresHabituales } from "../../planificador/profesoresHabituales";
// ── permisosUsuario: cuerpo compartido (inicio) ──
// `rutas`: pantallas del CRM que abre el permiso (prefijo exacto o subruta). `requiere`: permisos que lleva implícitos.
const PERMISOS_USUARIO = [
  { id: "planificar", nombre: "Planificar prácticas", para: "Ve la planificación de todos los profesores y crea, mueve y cancela prácticas, atiende las peticiones y envía la semana. Sin esto, cada profesor solo ve las suyas.", rutas: [], requiere: ["planificar_propias", "ver_agenda_todos"] },
  // «Planificar sus prácticas» (8/10/2026): lo mismo, pero SOLO en las prácticas en las que él es el profesor
  // (instructor_id === su user_id). Lo fuerzan c_putPractica, c_cancelPractica, c_bulkCancelPracticas y
  // c_sendPracticaSchedule (exigePlanificar). Ficha: docs/features/autoescuela-permiso-planificar-propias.md
  { id: "planificar_propias", nombre: "Planificar sus prácticas", para: "Crea, mueve y cancela solo las prácticas en las que él es el profesor: las nuevas nacen con él y no puede pasárselas a otro. Las peticiones de los alumnos y el envío de la semana siguen siendo de quien tenga «Planificar prácticas».", rutas: [] },
  { id: "ver_agenda_todos", nombre: "Ver la agenda de todos", para: "Ve también las prácticas de los demás profesores, sin poder tocarlas. Sin esto, solo ve las suyas.", rutas: [] },
  { id: "alumnos", nombre: "Alumnos", para: "Entra en Alumnos, ve sus fichas y puede darlos de alta, editarlos, importarlos y borrarlos.", rutas: ["/alumnos"] },
  // «Ver solo sus alumnos» (14/10/2026, Autoescuela Isa #26c): es un LÍMITE, no abre nada. En Alumnos, buscadores, el
  // modal de práctica, Planificar semana y el planificador solo le salen los alumnos de los que es UNO de sus
  // profesores habituales (c_alumnos.instructor_ids / instructor_id, 22/10/2026). Lo fuerza el SERVIDOR (c_getAlumnos filtra la respuesta; c_putAlumno y
  // c_deleteAlumno no dejan tocar los de otro; c_planificadorSemanal solo trabaja con los suyos). Los alumnos SIN
  // profesor habitual tampoco los ve. Ficha: docs/features/autoescuela-solo-sus-alumnos.md
  { id: "solo_sus_alumnos", nombre: "Ver solo sus alumnos", para: "En Alumnos, en los buscadores, al poner una práctica y al planificar solo le salen los alumnos de los que es el profesor habitual (lo pone la ficha de cada alumno). Los que no tienen profesor habitual tampoco los ve: pónselo en su ficha. Los que dé de alta nacen con él.", rutas: [] },
  { id: "cobros", nombre: "Registrar cobros", para: "Apunta pagos y cargos en la cuenta del alumno y entra en Pagos. Lleva también «Alumnos».", rutas: ["/pagos"], requiere: ["alumnos"] },
  { id: "facturacion", nombre: "Facturación y gastos", para: "Ve las facturas emitidas, sube las facturas de compra y descarga o envía a la gestoría el Excel de ingresos y gastos.", rutas: ["/facturacion"] },
  { id: "examenes", nombre: "Exámenes", para: "Apunta exámenes y sus resultados.", rutas: ["/examenes"] },
  { id: "flota", nombre: "Flota", para: "Da de alta y edita los coches, su ITV, seguro y mantenimiento.", rutas: ["/flota"] },
  { id: "chats", nombre: "Chats", para: "Lee y contesta los WhatsApp de los alumnos.", rutas: ["/chats", "/chat", "/contactos", "/iniciar-conversacion"] },
  { id: "ajustes", nombre: "Mensajes automáticos", para: "Cambia los avisos de WhatsApp a los alumnos, la duración y los tipos de clase. Los ajustes de la empresa, la suscripción y los trabajadores siguen siendo solo tuyos.", rutas: ["/mensajes-automaticos"] },
];
const PERMISOS_IDS = PERMISOS_USUARIO.map((p) => p.id);
// Lo que cualquier usuario abre siempre (su planificación y su fichaje).
const RUTAS_SIEMPRE = ["/planificacion", "/mi-fichaje"];
// Sección de «Secciones de la app» → permiso que la abre a un usuario que no es el dueño. Las que no están (Dashboard,
// Cursos, Fichajes) son solo del dueño.
const SECCION_PERMISO = { chats: ["chats"], examenes: ["examenes"], tests: ["alumnos"], cobros: ["cobros", "facturacion"], flota: ["flota"] };
const SECCIONES_SOLO_DUENO = ["dashboard", "cursos", "fichajes"];

/** Dueño = level 0 o user_id «admin» (mismo criterio que c_login, c_putPractica y utils/roles.js del front). */
function esDueno(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (String(payload.user_id) === "admin") return true;
  const lvl = payload.level !== undefined && payload.level !== null && payload.level !== "" ? parseInt(payload.level, 10) : 99;
  return lvl === 0;
}

/** Lo guardado (objeto plano, mapa M de DynamoDB o basura) → { id: bool } con TODOS los ids. Solo true cuenta. */
function normalizaPermisos(raw) {
  let obj = raw;
  if (obj && typeof obj === "object" && obj.M && typeof obj.M === "object") obj = obj.M;
  const out = {};
  for (const id of PERMISOS_IDS) {
    const v = obj && typeof obj === "object" ? obj[id] : undefined;
    out[id] = v === true || Boolean(v && typeof v === "object" && v.BOOL === true);
  }
  for (const p of PERMISOS_USUARIO) {
    if (out[p.id] && Array.isArray(p.requiere)) for (const r of p.requiere) out[r] = true;
  }
  return out;
}

/** Lo que llega al guardar → { value } (todos los ids) o { error } en español. null = quitarle todo. */
function validaPermisos(raw) {
  if (raw === null) return { value: normalizaPermisos({}) };
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return { error: "Los permisos deben ser una lista de casillas" };
  for (const [k, v] of Object.entries(raw)) {
    if (!PERMISOS_IDS.includes(k)) return { error: `Permiso desconocido: ${k}` };
    if (typeof v !== "boolean") return { error: `El permiso ${k} debe ser sí o no` };
  }
  return { value: normalizaPermisos(raw) };
}

/** ¿Tiene alguno? (para decir «Solo su planificación» en la lista de trabajadores). */
function tieneAlguno(permisos) {
  const p = normalizaPermisos(permisos);
  return PERMISOS_IDS.some((id) => p[id]);
}

/** Permiso que abre una ruta del CRM, null si es de las de siempre, «dueno» si es solo del dueño. */
function permisoDeRuta(pathname) {
  if (typeof pathname !== "string") return "dueno";
  if (RUTAS_SIEMPRE.some((r) => pathname === r || pathname.startsWith(r + "/"))) return null;
  for (const p of PERMISOS_USUARIO) {
    if (p.rutas.some((r) => pathname === r || pathname.startsWith(r + "/"))) return p.id;
  }
  return "dueno";
}

/** ¿Puede abrir esta ruta un usuario que NO es el dueño con estos permisos? */
function rutaPermitida(pathname, permisos) {
  const id = permisoDeRuta(pathname);
  if (id === null) return true;
  if (id === "dueno") return false;
  return normalizaPermisos(permisos)[id] === true;
}

/** Secciones (ids de «Secciones de la app») que NO ve un usuario que no es el dueño con estos permisos. */
function seccionesSinPermiso(permisos) {
  const p = normalizaPermisos(permisos);
  const fuera = [...SECCIONES_SOLO_DUENO];
  for (const [seccion, ids] of Object.entries(SECCION_PERMISO)) {
    if (!ids.some((id) => p[id])) fuera.push(seccion);
  }
  return fuera;
}

/**
 * Hasta dónde planifica quien NO es el dueño: "todas" («Planificar prácticas»), "propias" («Planificar sus prácticas»,
 * solo aquellas en las que él es el profesor) o null (solo mira la suya, como de fábrica).
 */
function alcancePlanificar(permisos) {
  const p = normalizaPermisos(permisos);
  if (p.planificar) return "todas";
  if (p.planificar_propias) return "propias";
  return null;
}

/** ¿Es suya esta práctica? El profesor de una práctica (instructor_id) es el user_id de c_usuarios. */
function esPracticaPropia(practica, userId) {
  if (!practica || typeof practica !== "object" || userId === undefined || userId === null || userId === "") return false;
  const iid = practica.instructor_id;
  return iid !== undefined && iid !== null && iid !== "" && String(iid) === String(userId);
}
/** ¿Ve solo los alumnos de los que es el profesor habitual? («Ver solo sus alumnos»; el dueño nunca). */
function soloSusAlumnos(permisos) {
  return normalizaPermisos(permisos).solo_sus_alumnos === true;
}

/**
 * ¿Es suyo este alumno? Lo es si él (user_id de c_usuarios) es UNO de sus profesores habituales (instructor_ids, con
 * instructor_id = el principal; 22/10/2026). Sin profesor → no.
 */
function esAlumnoPropio(alumno, userId) {
  if (!alumno || typeof alumno !== "object" || userId === undefined || userId === null || userId === "") return false;
  return profesoresHabituales(alumno).includes(String(userId));
}
// ── permisosUsuario: cuerpo compartido (fin) ──

export {
  PERMISOS_USUARIO, PERMISOS_IDS, RUTAS_SIEMPRE, SECCION_PERMISO, SECCIONES_SOLO_DUENO,
  esDueno, normalizaPermisos, validaPermisos, tieneAlguno, permisoDeRuta, rutaPermitida, seccionesSinPermiso,
  alcancePlanificar, esPracticaPropia,
};
